export const enforcementVisitOptions = [
  { key: "c", text: "Cash", value: "cash" },
  { key: "m", text: "Machine", value: "machine" },
  { key: "b", text: "Bingo", value: "bingo" },
  { key: "p", text: "Prize Payout", value: "prizePayout" },
  { key: "o", text: "Other", value: "other" },
];
